import templateUrl from 'emun.customer/customer-vendors-shipped.htm'
import controller from 'emun.customer/customer-vendors-shipped.controller'

export default {
    bindings: {
        customer: '<',
        repGroup: '@',
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};